export const THEME_DEFAULT = "bootstrap-v5";
export const SKIN_DEFAULT = "light";
